<script>
  export let selected = false;
</script>

<button class:selected on:click>
  <slot />
</button>

<style>
  button {
    position: relative;
    width: calc(100% - 50px);
    padding-left: 50px;
    margin-bottom: 20px;
    height: auto;
    color: #000000;
    background-color: transparent;
    font-family: 'raleway', sans-serif;
    text-transform: uppercase;
    font-weight: bold;
    text-align: left;
    font-size: 18px;
  }

  button:before {
    content: '';
    left: 5px;
    top: 13px;
    position: absolute;
    border: 2px solid black;
    border-radius: 999px;
    width: 10px;
    height: 10px;
  }

  button:hover {
    color: #3d0e28;
  }

  .selected {
    color: #3d0e28;
  }

  .selected::before {
    background-color: #3d0e28;
    border-color: #3d0e28;
  }
</style>
